/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('app').filter('trust', function($sce) {
	return $sce.trustAsHtml;
}).filter('momentToString', function() {
	return function(mom, toFormat) {
		if (typeof mom === 'undefined' || mom === null) {
			return;
		}
		if (typeof toFormat === 'undefined') {
			toFormat = 'DD MMM, HH:mm';
		}
		return mom.local().format(toFormat);
	};
}).filter('toLocal', function() {
	return function(string, toFormat, fromFormat) {
		if (typeof fromFormat === 'undefined') {
			fromFormat = 'YYYY-MM-DD HH:mm:ss';
		}
		return moment.utc(string, fromFormat).local().format(toFormat);
	};
}).filter('nullfilter', function() {
	return function(input, value_on_null, suffix, prefix) {
		if (typeof input === 'undefined' || input === null || input.length === 0) {
			return value_on_null;
		}
		return (prefix ? prefix : '') + ' ' + input + ' ' + (suffix ? suffix : '');
	};
}).filter('titlecase', function() {
	return function(input) {
		if (typeof input === 'undefined' || input === null || input.length === 0) {
			return '';
		}
		return input.replace(/\b([a-z])/g, function(_, initial) {
			return initial.toUpperCase();
		});
	};
});